/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// MESSAGE : POPUP : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
    popupmessage:{
        maxWidth: pxToEm(432),
        padding: pxToEm(18),

        //copy
        '& .title':{
            fontSize: pxToEm(12),
            margin: '0',
            // width: '70%'
        },
        '& .bodycopy':{
            fontSize: pxToEm(14),
            // textAlign: 'center',
            // width: '80%'
        },

        //CTAs
        '& .ctas':{
            '& .button':{
                width: '100%',
                marginBottom: pxToEm(10)
            }
        }
    }
});